import React from 'react'

function USDBLogo() {
  return (
    <svg id="a" className='usdb-logo' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514.92 110.5">
        <g>
            <path
            d="M77.3,98.19c-5.02,4.28-10.56,7.22-16.8,8.85-6.89,1.8-13.76,.97-20.59-.25-6.57-1.18-12.83-3.3-18.47-7-7.13-4.68-11.53-11.57-15.72-18.73C1.51,73.85-.11,66.19,.7,57.99c1.41-14.23,9.95-25.11,24.66-27.84,2.19-.41,4.44-.53,6.62-.96,.68-.13,1.5-.68,1.85-1.27,2.42-4.12,5.1-8.02,8.83-11.08,1.17-.96,1.25-1.9,.11-2.7-1.27-.9-2.66-2.04-4.11-2.23-7.36-.95-13.87,1.65-20.03,5.36-.16,.1-.24,.33-.36,.51,.56,.95,1.32,1.82,1.62,2.82,.59,2.03-.36,3.98-2.05,4.77-1.7,.79-3.86,.33-4.97-1.04-1.29-1.59-1.35-4.06,.32-5.53,3.25-2.84,6.48-5.83,10.16-8.02C34.48,4.15,46.68,1.55,59.57,3.12c6.41,.78,12.56,2.79,17.62,7.14,1.07,.92,1.96,2.03,2.81,2.92-4.57,1.07-8.98,1.77-13.16,3.16-7.31,2.42-12.95,7.3-17.71,13.23-.98,1.23-.75,2.19,.25,3.3,2.81,3.1,5.81,6.08,8.24,9.47,6.94,9.66,4.31,23.24-5.44,29.17-.22,.13-.46,.23-.98,.49,3.31-10.86,.36-19.32-9.1-25.57-1.43,7.67-.41,15.17,1.88,22.5,2.37,7.59,6.5,14.16,12.51,19.49,5.95,5.28,12.91,8.41,20.82,9.76Zm-2.71,1.86l-.2-.76c-.61-.12-1.21-.26-1.82-.34-3.24-.45-6.58-.54-9.7-1.39-11.35-3.08-19.37-10.42-25.19-20.37-5.86-10.04-8.58-20.91-8.56-32.49,0-2.35-.16-2.46-2.38-1.88-9.66,2.52-15.93,12.93-13.63,22.57,1.92,8.06,5.43,15.37,10.72,21.72,11.51,13.79,25.87,19.92,43.88,15.51,2.36-.58,4.59-1.7,6.88-2.58Z"
            style={{
                fill: 'white', 
                stroke:'white',
                strokeMiterlimit:'10'
            }}
            />
            <path
            d="M116.46,52.67c-2.14,0-4.09,.08-6.03-.06-.52-.04-1.2-.66-1.45-1.19-1.61-3.29-4-4.89-7.85-4.65-4.46,.27-8.95,.13-13.43,.04-1.75-.03-2.3,.58-2.29,2.3,.06,10.11,.03,20.22,.03,30.34,0,.81,0,1.62,0,2.42-3.85,.02-5.61-1.64-5.64-5.17-.05-5.79,0-11.58-.02-17.36,0-2.15-.78-2.73-2.83-2.07-2.08,.67-3.03,2.3-3.03,4.32,0,4.87,.22,9.75,.24,14.63,.03,5.18,5.41,9.44,10.87,9.62,8.78,.3,18.85-6.78,21.88-15.53,.86-2.47,1.33-5.11,1.69-7.71,.44-3.15-.47-4.38-3.51-5.61-.26-.1-.42-.45-.92-1.01h14.76c0,.27,.04,.51,0,.52-4.41,1.52-4.9,5.45-5.67,9.19-2.27,11.06-7.81,19.72-18.3,24.73-7.97,3.81-17.77,1.95-23-4.33-2.73-3.28-3.59-7.19-3.72-11.29-.13-4.18-.08-8.37-.07-12.55,0-2.08-.3-3.91-2.76-4.53-.36-.09-.57-.73-.86-1.12l.23-.71c2.63,0,5.26,.06,7.89-.02,2.2-.06,5.22,.52,6.37-.66,1.17-1.19,.59-4.18,.59-6.38,.01-7.18-.11-14.37-.07-21.55,.02-2.9-1.01-4.92-3.81-6.05-1.78-.72-3.44-1.71-5.74-2.88,1.67-.36,2.71-.7,3.76-.8,8.74-.86,17.36-.94,24.97,4.46,5.27,3.74,8.49,8.54,8.21,15.3-.05,1.1,.63,2.39,1.35,3.31,.84,1.08,1.98,1.99,3.15,2.73,3.33,2.11,4.42,5.36,4.99,9.34Zm-30.78-20.35c0,2.22-.02,4.45,0,6.67,.02,1.41,.69,2.18,2.2,2.15,2.65-.04,5.3,.06,7.95-.05,3.74-.15,5.51-2.54,4.72-6.2-1.17-5.4-7.54-10.58-13.07-10.7-1.23-.02-1.83,.39-1.82,1.65,.02,2.15,0,4.31,0,6.46Z"
            style={{
                fill: 'white', 
                stroke:'white',
                strokeMiterlimit:'10'
            }}
            />
            <path
            d="M65.99,33.63c.04,2.41-1.61,4.12-3.99,4.14-2.42,.02-4.19-1.67-4.19-3.99,0-2.15,2.04-4.21,4.16-4.2,2.11,.02,3.98,1.9,4.02,4.05Z"
            style={{
                fill: 'white', 
                stroke:'white',
                strokeMiterlimit:'10'
            }}
            />
        </g>
        <rect
            x="151.12"
            y="8.73"
            width="2"
            height="93.28"
            rx="1"
            ry="1"
            transform="translate(304.23 110.75) rotate(-180)"
            style={{
                fill: 'white', 
                stroke:'white',
                strokeMiterlimit:'10'
            }}
        />
        <text
            transform="translate(185.28 45.18)"
            style={{
                fill: 'white', 
                stroke:'white',
                strokeMiterlimit:'10'
            }}
        >
            <tspan style={{
                fontFamily: 'AdobeArabic-Regular, Adobe Arabic',
                fontSize: '61px'
            }}>
                <tspan x="0" y="0">
                    جامعة البليدة 1
                </tspan>
            </tspan>
            <tspan style={{
                fontFamily: 'Algerian, Algerian',
                fontSize: '35px',
                strokeWidth: '.5px',
                stroke: '#d8d8d8'
            }}>
            <tspan x="0" y="56">
                UNIVERSITE BLIDA 1
            </tspan>
            </tspan>
        </text>
    </svg>

  )
}

export default USDBLogo